(function() {
  const WISHLIST_KEY = 'shoptiby-wishlist';

  // Inject CSS dynamically
  const style = document.createElement('style');
  style.textContent = `
    /* Wishlist Header Badge */
    .wishlist-count-badge {
      display: none;
      position: absolute !important;
      top: -6px !important;
      right: -8px !important;
      background-color: #C70025 !important;
      color: #ffffff !important;
      font-size: 10px !important;
      font-weight: 700 !important;
      width: 16px !important;
      height: 16px !important;
      border-radius: 50% !important;
      justify-content: center !important;
      align-items: center !important;
      padding: 0 !important;
    }

    /* Wishlist Toggles Active State (heart filled) */
    .js-wishlist-toggle.is-active svg {
      fill: #C70025 !important;
      stroke: #C70025 !important;
    }

    /* Wishlist Page Styling */
    #custom-wishlist-page-wrapper {
      padding: 40px 0;
      max-width: 1200px;
      margin: 0 auto;
    }
    .wishlist-page-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 30px;
    }
    @media screen and (max-width: 989px) {
      .wishlist-page-grid {
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
      }
    }
    @media screen and (max-width: 767px) {
      .wishlist-page-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 15px;
      }
    }
    .wishlist-product-card {
      position: relative;
      background: #ffffff;
      border: 1px solid #f0f0f0;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      transition: box-shadow 0.2s ease;
    }
    .wishlist-product-card:hover {
      box-shadow: 0 4px 12px rgba(0,0,0,0.05);
    }
    .wishlist-remove-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background: #ffffff;
      border: 1px solid #eaeaea;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      color: #888888;
      z-index: 10;
      transition: all 0.2s ease;
      padding: 0;
    }
    .wishlist-remove-btn:hover {
      background: #f3f4f6;
      color: #000000;
    }
    .wishlist-product-image {
      width: 100%;
      aspect-ratio: 1;
      background: #f7f7f7;
      display: flex;
      justify-content: center;
      align-items: center;
      overflow: hidden;
    }
    .wishlist-product-image img {
      max-width: 90%;
      max-height: 90%;
      object-fit: contain;
    }
    .wishlist-product-info {
      padding: 16px;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
    }
    .wishlist-product-title {
      font-size: 14px;
      font-weight: 600;
      color: #1a1a1a;
      text-decoration: none;
      margin-bottom: 8px;
      line-height: 1.4;
      height: 38px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .wishlist-product-price-wrapper {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .wishlist-compare-price {
      font-size: 13px;
      text-decoration: line-through;
      color: #888888;
    }
    .wishlist-price {
      font-size: 15px;
      font-weight: 700;
      color: #000000;
    }
    .wishlist-add-to-cart-btn {
      width: 100%;
      background: #002D62;
      color: #ffffff;
      border: none;
      padding: 10px;
      font-size: 12px;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 0.5px;
      border-radius: 4px;
      cursor: pointer;
      margin-top: auto;
      transition: background 0.2s ease;
    }
    .wishlist-add-to-cart-btn:hover {
      background: #001f44;
    }
    .wishlist-empty-state {
      text-align: center;
      padding: 60px 20px;
    }
    .wishlist-empty-state p {
      font-size: 16px;
      color: #666666;
      margin-bottom: 20px;
    }
    .wishlist-continue-shopping {
      display: inline-block;
      background: #002D62;
      color: #ffffff;
      text-decoration: none;
      padding: 12px 30px;
      font-size: 14px;
      font-weight: 700;
      border-radius: 4px;
      text-transform: uppercase;
      letter-spacing: 0.5px;
    }
  `;
  document.head.appendChild(style);

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || [];
    } catch (e) {
      return [];
    }
  }

  function setWishlist(wishlist) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(wishlist));
    updateHeaderWishlistCount();
    updateTogglesState();
    if (window.location.pathname.includes('/pages/wishlist')) {
      renderWishlistPage();
    }
  }

  function toggleWishlist(product) {
    let wishlist = getWishlist();
    const index = wishlist.findIndex(item => String(item.id) === String(product.id));
    if (index > -1) {
      wishlist.splice(index, 1);
    } else {
      wishlist.push(product);
    }
    setWishlist(wishlist);
  }

  function isWishlisted(productId) {
    return getWishlist().some(item => String(item.id) === String(productId));
  }

  function updateHeaderWishlistCount() {
    const wishlist = getWishlist();
    const badges = document.querySelectorAll('.wishlist-count-badge');
    badges.forEach(badge => {
      badge.textContent = wishlist.length;
      badge.style.setProperty('display', wishlist.length > 0 ? 'flex' : 'none', 'important');
    });
  }

  function updateTogglesState() {
    const toggles = document.querySelectorAll('.js-wishlist-toggle');
    toggles.forEach(toggle => {
      const productId = toggle.dataset.productId;
      if (isWishlisted(productId)) {
        toggle.classList.add('is-active');
      } else {
        toggle.classList.remove('is-active');
      }
    });
  }

  // Handle wishlist button clicks
  document.addEventListener('click', function(e) {
    const toggle = e.target.closest('.js-wishlist-toggle');
    if (!toggle) return;

    e.preventDefault();
    e.stopPropagation();

    const product = {
      id: toggle.dataset.productId,
      title: toggle.dataset.productTitle,
      handle: toggle.dataset.productHandle,
      url: toggle.dataset.productUrl,
      featured_image: toggle.dataset.productImage,
      price: toggle.dataset.productPrice,
      compare_at_price: toggle.dataset.productComparePrice || ''
    };

    if (!product.id) return;

    toggleWishlist(product);
  });

  // Render wishlist page
  function renderWishlistPage() {
    const container = document.querySelector('.main-page-content') || document.querySelector('.page-content') || document.querySelector('.section-content-wrapper');
    if (!container) return;

    let wishlistWrapper = document.getElementById('custom-wishlist-page-wrapper');
    if (!wishlistWrapper) {
      wishlistWrapper = document.createElement('div');
      wishlistWrapper.id = 'custom-wishlist-page-wrapper';
      container.innerHTML = '';
      container.appendChild(wishlistWrapper);
    }

    const wishlist = getWishlist();

    if (wishlist.length === 0) {
      wishlistWrapper.innerHTML = `
        <div class="wishlist-empty-state">
          <p>Your wishlist is currently empty.</p>
          <a href="/collections/all" class="wishlist-continue-shopping">Continue Shopping</a>
        </div>
      `;
      return;
    }

    let html = '<div class="wishlist-page-grid">';
    wishlist.forEach(product => {
      html += `
        <div class="wishlist-product-card" data-product-id="${product.id}">
          <button type="button" class="wishlist-remove-btn" data-product-id="${product.id}">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
          
          <div class="wishlist-product-image">
            <a href="${product.url}">
              <img src="${product.featured_image}" alt="${product.title}" loading="lazy">
            </a>
          </div>
          
          <div class="wishlist-product-info">
            <a href="${product.url}" class="wishlist-product-title">${product.title}</a>
            <div class="wishlist-product-price-wrapper">
              ${product.compare_at_price ? `<span class="wishlist-compare-price">${product.compare_at_price}</span>` : ''}
              <span class="wishlist-price">${product.price}</span>
            </div>
            
            <button type="button" class="wishlist-add-to-cart-btn" data-product-handle="${product.handle}" data-product-url="${product.url}">
              Add To Cart
            </button>
          </div>
        </div>
      `;
    });
    html += '</div>';

    wishlistWrapper.innerHTML = html;

    // Attach listeners
    wishlistWrapper.querySelectorAll('.wishlist-remove-btn').forEach(btn => {
      btn.addEventListener('click', function(e) {
        const id = btn.dataset.productId;
        let list = getWishlist();
        list = list.filter(item => String(item.id) !== String(id));
        setWishlist(list);
      });
    });

    wishlistWrapper.querySelectorAll('.wishlist-add-to-cart-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const url = btn.dataset.productUrl;
        window.location.href = url;
      });
    });
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', function() {
    updateHeaderWishlistCount();
    updateTogglesState();
    if (window.location.pathname.includes('/pages/wishlist')) {
      renderWishlistPage();
    }
  });

  // Re-run on load in case DOM elements load late
  window.addEventListener('load', function() {
    updateHeaderWishlistCount();
    updateTogglesState();
    if (window.location.pathname.includes('/pages/wishlist')) {
      renderWishlistPage();
    }
  });

  // MutationObserver to automatically keep dynamically added wishlist toggles in sync (e.g. infinite scroll)
  if (typeof window !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      updateTogglesState();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();

